import { render, staticRenderFns } from "./OrganizationSSO.vue?vue&type=template&id=7d987008&scoped=true"
import script from "./OrganizationSSO.vue?vue&type=script&lang=js"
export * from "./OrganizationSSO.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSSO.vue?vue&type=style&index=0&id=7d987008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d987008",
  null
  
)

export default component.exports